import { createSlice } from "@reduxjs/toolkit";
import { UserModel } from "../../../models/persisted/userModel";
import { resetPersistedState } from "../../actions/actions";
export interface PersistedState {
  //login
  user: UserModel;
}

const initialState: PersistedState = {
  //login
  user: {} as UserModel,
};

export const persistedSlice = createSlice({
  name: "persisted",
  initialState,
  reducers: {
    //login
    setUser: (state, action) => {
      state.user = action.payload;
    },
    //internal
    setPerfil: (state, action) => {
      state.user.perfil = action.payload;
    },
  },
  // extraReducers: (builder) => {
  //   //Resetar estado persistido
  //   builder.addCase(resetPersistedState, () => initialState);
  // },
});

export const {
  //login
  setUser,
  //internal
  setPerfil,
} = persistedSlice.actions;

export default persistedSlice.reducer;
